const alternativeCalorie = {
  getlist: 'AlternativeCalorie/getlist',
  add: 'AlternativeCalorie/add',
  update: 'AlternativeCalorie/update',
  remove: 'AlternativeCalorie/remove',
  get: 'AlternativeCalorie/get'
}

export default alternativeCalorie